var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from "react";
import { Form, Formik } from "formik";
import { FormatForm } from "./forms/format-form/format-form";
import { ProgramForm } from "./forms/program-form/program-form";
import generatorFormInitialValues from "./generator-inital-values";
import { Stepper } from "./stepper/stepper";
import { InfoForm } from "./forms/info-form/info-form";
import { PrintForm } from "./forms/print-form/print-form";
import { Step } from "./generator-enum";
import { PreviewPdf } from "./forms/preview-pdf/preview-pdf";
import { DownloadPdf } from "./forms/download-pdf/download-pdf";
import { validateGeneratorForm } from "./generator-validation-scheme";
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { getTooltips } from "./generator-api";
import { getTooltipText } from "./generator-tooltips";
var getTooltipsForStep = function (tooltips, actualStep) {
    var selectedTooltips = tooltips.find(function (_a) {
        var step = _a.step;
        return step === actualStep;
    });
    if (!selectedTooltips) {
        return null;
    }
    var tooltipsArray = selectedTooltips['tooltips'];
    return tooltipsArray;
};
var getStepSubheading = function (currentStep, program, format) {
    // const {
    //   values: { program, format }
    // } = useFormikContext();
    // console.log(values);
    // console.log(program);
    // console.log(format);
    return currentStep.specialSubtitle && currentStep.specialSubtitle[program] && format == 'billboard_small_single' ? (React.createElement("div", { dangerouslySetInnerHTML: { __html: currentStep.specialSubtitle[program] } })) : (React.createElement(React.Fragment, null));
};
var steps = [
    {
        number: 1,
        name: "Výběr programu",
        title: "Vyberte program",
        step: Step.Program,
    },
    {
        number: 2,
        name: "Výběr formátu",
        title: "Vyberte formát",
        toltip: "toto je free text tool tipu pre vyber formatu",
        step: Step.Program,
    },
    {
        number: 3,
        name: "Vložení údajů",
        title: "Vložte údaje",
        toltip: "toto je free text tool tipu pre vlozenie udajov",
        step: Step.Program,
    },
    {
        number: 4,
        name: "Náhled",
        title: "Náhled",
        subtitle: "Než přejdete na další krok, zkontrolujte, zda jste vše doplnili správně. Pokud najdete chybu, vraťte se o krok zpět a údaje opravte.",
        specialSubtitle: {
            mf: "Máte-li zájem o výměnu fotografie za vlastní vizualizaci, zašlete podklad na e-mail <a href='mailto:publicita@sfzp.cz'>publicita@sfzp.cz</a>. "
        },
        step: Step.Preview,
    },
    {
        number: 5,
        name: "Nastavení pro tisk",
        title: "Nastavení pro tisk",
        toltip: "toto je free text tool tipu pre nastavenie tlace",
        step: Step.Program,
    },
    {
        number: 6,
        name: "Uložení souboru",
        title: "Uložte soubor",
        step: Step.Program,
    },
];
export var Generator = function () {
    var _a, _b, _c;
    var _d = __read(useState(0), 2), step = _d[0], setStep = _d[1];
    var _e = getTooltips(), tooltips = _e.tooltips, loadingTooltips = _e.loadingTooltips, messageTooltips = _e.messageTooltips;
    var currentStep = (_a = steps[step]) !== null && _a !== void 0 ? _a : null;
    var prevStep = (_b = steps[step - 1]) !== null && _b !== void 0 ? _b : null;
    var nextStep = (_c = steps[step + 1]) !== null && _c !== void 0 ? _c : null;
    var setGeneratorStep = function (step) {
        setStep(step);
    };
    var scrollToTop = function () {
        var page = document.getElementById('page__body');
        if (page) {
            page.scrollTo({ top: 0, behavior: "smooth" });
        }
    };
    var renderStepContent = function (step) {
        switch (step) {
            case 0:
                return React.createElement(ProgramForm, { tooltips: getTooltipsForStep(tooltips, step) });
            case 1:
                return React.createElement(FormatForm, { tooltips: getTooltipsForStep(tooltips, step) });
            case 2:
                return React.createElement(InfoForm, { tooltips: getTooltipsForStep(tooltips, step) });
            case 3:
                return React.createElement(PreviewPdf, null);
            case 4:
                return React.createElement(PrintForm, { tooltips: getTooltipsForStep(tooltips, step) });
            case 5:
                return React.createElement(DownloadPdf, { setGeneratorStep: setGeneratorStep });
            default:
                return React.createElement(React.Fragment, null);
        }
    };
    var onValidate = function (values) {
        return validateGeneratorForm(step, values);
    };
    var handleSubmit = function (values) {
        // console.log(step);
        // if (step !== 2) {
        // console.log("step is not 2")
        if (values['format'] === "poster_electronic_single" && step == 3) {
            setStep(step + 2);
        }
        else {
            setStep(step + 1);
        }
        // }
        scrollToTop();
    };
    var handleReset = function (values) {
        setStep(0);
        scrollToTop();
    };
    return (React.createElement(GoogleReCaptchaProvider
    // reCaptchaKey="6LdtLiofAAAAACg3NApZsiJfuivCKkUBLzPdJsuj"
    , { 
        // reCaptchaKey="6LdtLiofAAAAACg3NApZsiJfuivCKkUBLzPdJsuj"
        reCaptchaKey: "6Lds9yofAAAAAIHzUKtqncS79gAfmp39CBVvP29i", language: "cs" },
        React.createElement("div", { className: "generator" },
            React.createElement("div", { className: "generator__stepper" },
                React.createElement(Stepper, { currentStep: step, steps: steps })),
            React.createElement("div", { className: "generator__step" },
                React.createElement(Formik, { initialValues: generatorFormInitialValues, enableReinitialize: true, validate: onValidate, onSubmit: handleSubmit, onReset: handleReset }, function (_a) {
                    var setFieldValue = _a.setFieldValue, submitForm = _a.submitForm, resetForm = _a.resetForm, errors = _a.errors, values = _a.values, isValid = _a.isValid;
                    return (React.createElement(Form, null,
                        React.createElement("div", { className: "generator-step" },
                            React.createElement("div", { className: "generator-step__container" }, loadingTooltips || tooltips == undefined ? (React.createElement("div", { className: "generator-step__message" }, "Na\u010D\u00EDtan\u00ED")) : (messageTooltips != undefined ? (React.createElement("div", { className: "generator-step__message" }, "Aplikaci se nezda\u0159ilo na\u010D\u00EDst")) : (React.createElement(React.Fragment, null,
                                React.createElement("h2", { className: "generator-step__heading" },
                                    currentStep.number,
                                    ". ",
                                    currentStep.title,
                                    getTooltipText(getTooltipsForStep(tooltips, step), "title") ? (React.createElement("div", { className: "generator-step__tooltip" },
                                        "i",
                                        React.createElement("div", { className: "generator-step__tooltip-window" }, getTooltipText(getTooltipsForStep(tooltips, step), "title")))) : (React.createElement(React.Fragment, null))),
                                React.createElement("div", { className: "generator-step__subheading" }, currentStep.subtitle),
                                React.createElement("div", { className: "generator-step__subheading" }, getStepSubheading(currentStep, values.program, values.format)),
                                React.createElement("div", { className: "generator-step__wrapper" },
                                    React.createElement("div", { className: "generator-step__controls back" }, prevStep ? (React.createElement("div", { className: "control-button" },
                                        React.createElement("div", { className: "control-button__icon control-button__icon--prev", onClick: function () {
                                                if (values['format'] === "poster_electronic_single" && step == 5) {
                                                    setStep(step - 2);
                                                }
                                                else {
                                                    setStep(step - 1);
                                                }
                                                scrollToTop();
                                                setFieldValue("stepActive", true);
                                            } }),
                                        React.createElement("div", { className: "control-button__title" }))) : (React.createElement("div", { className: "control-button control-button--hidden" }))),
                                    React.createElement("div", { className: "generator-step__form" }, renderStepContent(step)),
                                    React.createElement("div", { className: "generator-step__controls next" }, nextStep ? (React.createElement("div", { className: "control-button" },
                                        React.createElement("div", { className: "control-button__icon control-button__icon--next", onClick: function () {
                                                submitForm();
                                                // if(isValid && step === 2) {
                                                //   if (values['format'] === "poster_electronic_single" && step == 3) {
                                                //     setStep(step + 2);
                                                //   } else {
                                                //     setStep(step + 1);
                                                //   }
                                                // }
                                                setFieldValue("stepActive", true);
                                            } }),
                                        React.createElement("div", { className: "control-button__title" }))) : (React.createElement("div", { className: "control-button control-button--hidden" })))))))))));
                })))));
};
